module.exports = "https://cdn.dove.it/_next/static/public/assets/building-sites/003.1275ad176f3c141304b05ef16ff70ce4.jpg";